import React, { ReactNode, useEffect, useState } from 'react'

import { validateAccessCode } from '../../services/user.service'
import { logger } from '../../services/logger'
import {
  useBranchLinkData,
  ReferralLinkData
} from '../../services/branch.service'

import { BranchUrlParameters } from '../../domain/branch'
import { useConfiguration } from '../AppConfigProvider/AppConfigProvider'
import { PacelineLoaderIcon } from '../Icons/PacelineLoaderIcon'
import { MainPageBox } from '../DisplayHelpers/MainPageBox'

// parse and act on Branch Link Data
const BranchLinkContainer: React.FC<{ children: ReactNode }> = ({
  children
}) => {
  const { setPromotionCode } = useConfiguration()
  const [loading, setLoading] = useState<boolean>(false)

  logger.debug('BranchLinkContainer')

  const storeLinkData = async (data: ReferralLinkData): Promise<void> => {
    logger.info('BranchLinkContainer: Storing Branch Link Data')

    const { promo_code, referral_code } = data

    if (promo_code) {
      setPromotionCode(promo_code)
      localStorage.setItem(BranchUrlParameters.PROMO_CODE, promo_code)
    }

    if (referral_code) {
      ;(await validateAccessCode(referral_code)) &&
        localStorage.setItem(BranchUrlParameters.REFERRAL_CODE, referral_code)
    }
    logger.debug('BranchLinkContainer setLoading(false)')
    setLoading(false)
  }

  useEffect(() => {
    if (!loading) {
      logger.debug('BranchLinkContainer setLoading(true)')
      setLoading(true)
      useBranchLinkData(storeLinkData)
    }
  }, [])

  return loading ? (
    <MainPageBox>
      <div style={{ marginTop: 200 }}>
        <PacelineLoaderIcon />
      </div>
    </MainPageBox>
  ) : (
    <>{children}</>
  )
}

export default BranchLinkContainer
